module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-block', {
    ref: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    ref: "slider",
    staticClass: "slider"
  }, [_vm._l((_vm.blocks), function(block) {
    return [_c('content-block', {
      ref: "block",
      refInFor: true,
      attrs: {
        "item": block
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    ref: "contactOverlay",
    staticClass: "contact-overlay"
  }, [_c('div', {
    staticClass: "content-block--video--close",
    on: {
      "click": _vm.toggleOverlay
    }
  }, [_c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-overlay--container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "logo"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Call +31 6 55 10 63 20"), _c('br'), _vm._v("\n                    or "), _c('a', {
    staticClass: "mail",
    attrs: {
      "href": "mailto:mail@johnhorjus.nl"
    }
  }, [_vm._v("mail@johnhorjus.nl")])]), _vm._v(" "), _c('a', {
    staticClass: "linkedIn",
    attrs: {
      "href": "https://www.linkedin.com/in/johnhorjus/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/linkedin.png",
      "alt": "linkedin"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-fallback"
  }, [_c('div', {
    staticClass: "mobile-fallback--inner"
  }, [_c('img', {
    attrs: {
      "src": "static/images/rotate.png",
      "alt": "rotate"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Please turn your device.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f8c957c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 15
// module chunks = 1